<template>
  <div>
    <v-switch
      v-model="mapped"
      label="Display day night overlay"
      :dense="true"
      class="mt-0"
    ></v-switch>
  </div>
</template>

<script>
import lodashGet from "lodash/get";

import { mapGetters } from "vuex";
import {
  GET_DAY_NIGHT_OVERLAY_REFRESH_MAP,
  SAVE_PREFERENCES,
} from "@/store/actions.type";
import {
  MODULE_PREFIX_MAP,
  MODULE_PREFIX_USER,
  MODULE_PREFIX_DAY_NIGHT_OVERLAY,
} from "@/store";
import { mapPolygonData, removeMapData } from "@/common/maps/features";
import { MAIN_MAP_ID } from "@/common/constants/maps";

import GeoJSONTerminator from "@webgeodatavore/geojson.terminator";
import { getDefaultPolygonOptions } from "@/common/maps/styles";
import { EVENT_ACTIONS, EVENT_CATEGORIES } from "@/common/constants/analytics";

const LAYER_NAME = "dayNightOverlay";

export default {
  name: "DayNightOverlay",
  components: {},
  data: () => ({
    mapped: false,
  }),
  async mounted() {
    this.getPrefs();
  },
  computed: {
    ...mapGetters({
      refreshMap: MODULE_PREFIX_DAY_NIGHT_OVERLAY + "refreshMap",
      maps: MODULE_PREFIX_MAP + "maps",
      preferences: MODULE_PREFIX_USER + "preferences",
    }),
    map() {
      return this.maps[MAIN_MAP_ID];
    },
    isUsingDefaultPlaces() {
      for (let i = 0; i < this.places.length; i++) {
        if (this.places[i].isDefaultLayer) {
          return true;
        }
      }
      return false;
    },
    supportImg() {
      return require("@/assets/images/miscellaneous/places_example.png");
    },
  },
  methods: {
    updateOverlayOnMap() {
      if (this.map) {
        let geoJSON = new GeoJSONTerminator({
          resolution: 0.5,
        });
        removeMapData(this.map, LAYER_NAME + "-polygon");
        if (this.mapped) {
          this.addToMap(geoJSON);
          this.handlePageTrackerEvent(
            EVENT_CATEGORIES.settings,
            EVENT_ACTIONS.enabled,
            "Day Night Overlay"
          );
        }
      }
    },
    getLayerId(id) {
      return `places-${id}`;
    },
    addToMap(geoJSON) {
      let source = geoJSON;

      const PARAMS = {
        id: LAYER_NAME,
      };

      const options = getDefaultPolygonOptions(PARAMS);
      let overlayColor = "#000000";
      let overlayOpacity = 0.1;

      options.polygonLayerOptions.paint["fill-color"] = overlayColor;
      options.polygonLayerOptions.paint["fill-opacity"] = overlayOpacity;
      options.polygonLayerOptions.paint["fill-outline-color"] = "rgba(0,0,0,0)";
      options.polygonLayerOptions.hypDisableHover = true;

      mapPolygonData({
        id: LAYER_NAME,
        data: source,
        polygonOptions: options,
        map: this.map,
      });
    },
    getPrefs() {
      if (lodashGet(this.preferences, "dayNightLayerShow")) {
        this.mapped = true;
      }
    },
    savePrefs() {
      let preferences = this.preferences;
      preferences.dayNightLayerShow = this.mapped;
      this.$store.dispatch(MODULE_PREFIX_USER + SAVE_PREFERENCES, preferences);
      preferences = null;
    },
  },
  watch: {
    mapped: {
      handler() {
        this.updateOverlayOnMap();
        this.savePrefs();
      },
    },
    refreshMap: {
      handler() {
        this.updateOverlayOnMap();
        this.$store.dispatch(
          MODULE_PREFIX_DAY_NIGHT_OVERLAY + GET_DAY_NIGHT_OVERLAY_REFRESH_MAP,
          false
        );
      },
    },
  },
};
</script>

<style scoped>
.hyp-places-support-img {
  width: 235px;
}
</style>
